import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DropdownFilter, DropdownSelect, useDropdown } from 'shared/components/DropdownFilter';
import { useFilterChangeCallback, useShowSearchMetaTooltip } from 'shared/hooks';
import { selectReadyBusinessTypesFilter } from 'shared/selectors/filters/readyBusinessTypes';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { TSelectValue } from 'shared/types/filters';

import { EJsonQueryReadyBusinessType } from '../../../packages/api-models/common/json_query';

import { FILTER_KEY } from './constants';

export const BusinessAppointmentsContainer: FC = () => {
  const { label, value, options } = useSelector(selectReadyBusinessTypesFilter);
  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  const dropdownState = useDropdown(FILTER_KEY);
  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const handleChange = useCallback(
    (next: TSelectValue) => {
      const nextValue = Array.isArray(next) ? (next as EJsonQueryReadyBusinessType[]) : null;
      onChange({ action: 'setReadyBusinessTypes', arguments: [nextValue && nextValue.length ? nextValue : null] });
    },
    [onChange],
  );

  return (
    <DropdownFilter
      {...dropdownState}
      buttonLabel={label}
      showTooltip={showTooltip}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={<DropdownSelect multiple options={options} value={value} onChange={handleChange} />}
    />
  );
};
